module.exports = __webpack_public_path__ + "img/hardware.26de4e87.jpeg";